import React from 'react';
import ConsultaProductos from './consulta_productos';

function Productos(props) {
	return (	
		<ConsultaProductos propiedades={props} />
	);
}

export default Productos;
